<script setup lang="ts">
import type { IVerticalElement } from '~/interfaces/dto/games/response';
import CategoryGrid from '~/components/category/category-grid.vue';
import Tabs from '~/components/design-system/tabs/tabs.vue';
import Tab from '~/components/design-system/tabs/tab.vue';

interface Props {
  searchTabs: IVerticalElement[];
  totalResults: number;
  searchQuery: string;
}

const props = withDefaults(defineProps<Props>(), {});
const activeTab = ref<string>('1');
const slugify = useSlugify;

watchEffect(() => {
  if (!props.searchTabs[+activeTab.value - 1]) activeTab.value = '1';
});
</script>

<template>
  <div>
    <Tabs
      :default-tab="`${activeTab}`"
      header-container-class="sticky top-0 z-10 my-2"
      @tab-change="activeTab = $event"
    >
      <template #tabList>
        <Tab
          v-for="(item, index) in searchTabs"
          :id="String(index + 1)"
          :key="index"
          :title="$t(`vertical.${slugify(item.vertical)}`)"
          class="max-h-[50dvh] overflow-auto h-full"
        >
          <CategoryGrid
            in-modal
            :games="item?.data"
            lazy-load-more
            :max-size="item?.count"
            :card-props="{
              parentComponent: 'search',
              gameUrlWrapperProps: {
                query: {
                  searchTab: slugify(item.vertical),
                  ...(!!searchQuery && { searchQuery }),
                },
              },
            }"
            :class="{ '!mt-2': searchTabs.length < 2 }"
          />
        </Tab>
      </template>
    </Tabs>
  </div>
</template>

<style scoped lang="scss"></style>
